import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAddressInput } from "@/hooks/user-info-form/useAddressInput";

export function AddressInput() {
  const {
    user,
    errors,
    t,
    handleChange,
    handleBlur
  } = useAddressInput();

  return (
    <div className="space-y-2">
      <Label className={"text-base"}>{t("userInfoForm.address")}</Label>
      <div className="grid grid-cols-[2fr_1fr] gap-2">
        <div>
          <Label htmlFor="street">{t("userInfoForm.street")}</Label>
          <Input
            id="street"
            value={user?.address.street || ""}
            onChange={(e) => handleChange("street", e.target.value)}
            onBlur={(e) => handleBlur("street", e.target.value)}
            placeholder={t("userInfoForm.streetPlaceholder")}
            className={errors.street ? "border-red-500" : ""}
          />
          {errors.street && <p className="text-sm text-red-500 mt-1">{errors.street}</p>}
        </div>
        <div>
          <Label htmlFor="houseNumber">{t("userInfoForm.houseNumber")}</Label>
          <Input
            id="houseNumber"
            value={user?.address.houseNumber || ""}
            onChange={(e) => handleChange("houseNumber", e.target.value)}
            onBlur={(e) => handleBlur("houseNumber", e.target.value)}
            placeholder={t("userInfoForm.houseNumberPlaceholder")}
            className={errors.houseNumber ? "border-red-500" : ""}
          />
          {errors.houseNumber && <p className="text-sm text-red-500 mt-1">{errors.houseNumber}</p>}
        </div>
      </div>
      <div className="grid grid-cols-[2fr_1fr] gap-2">
        <div>
          <Label htmlFor="city">{t("userInfoForm.city")}</Label>
          <Input
            id="city"
            value={user?.address.city || ""}
            onChange={(e) => handleChange("city", e.target.value)}
            onBlur={(e) => handleBlur("city", e.target.value)}
            placeholder={t("userInfoForm.cityPlaceholder")}
            className={errors.city ? "border-red-500" : ""}
          />
          {errors.city && <p className="text-sm text-red-500 mt-1">{errors.city}</p>}
        </div>
        <div>
          <Label htmlFor="postCode">{t("userInfoForm.postCode")}</Label>
          <Input
            id="postCode"
            value={user?.address.postCode || ""}
            onChange={(e) => handleChange("postCode", e.target.value)}
            onBlur={(e) => handleBlur("postCode", e.target.value)}
            placeholder={t("userInfoForm.postCodePlaceholder")}
            className={errors.postCode ? "border-red-500" : ""}
          />
          {errors.postCode && <p className="text-sm text-red-500 mt-1">{errors.postCode}</p>}
        </div>
      </div>
    </div>
  );
}
